export default __webpack_public_path__ + "static/media/dummy-blog.c8694389.jpg";